var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCode = function SvgIconCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M4.9 4.16a.8.8 0 0 1 .125 1.125l-2.8 3.5 2.8 3.5a.8.8 0 1 1-1.25 1l-3.2-4a.8.8 0 0 1 0-1l3.2-4A.8.8 0 0 1 4.9 4.162M11.1 4.16a.8.8 0 0 0-.124 1.125l2.8 3.5-2.8 3.5a.8.8 0 1 0 1.25 1l3.2-4a.8.8 0 0 0 0-1l-3.2-4a.8.8 0 0 0-1.125-.124M9.197 4.014c.427.117.687.56.58.988L7.77 12.994a.78.78 0 0 1-.968.563.82.82 0 0 1-.578-.988L8.23 4.577a.78.78 0 0 1 .967-.563",
    clipRule: "evenodd"
  })));
};
export default SvgIconCode;